
import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';

@Entity('machines_needle_mapping')
export class MachinesNeedleMappingEntity {

    @PrimaryGeneratedColumn('increment', {
        name: 'id'
    })
    id: number;

    @Column('varchar', {
        name: 'styles_id',
        nullable: false,
    })
    stylesId: string;

    @Column('varchar', {
        name: 'machines_id',
        nullable: false,
    })
    machinesId: string;

    @Column('varchar', {
        name: 'needle_model_id',
        nullable: false,
    })
    needleModelId: string;

    @Column('varchar', {
        name: 'needle_point_type_id',
        nullable: false,
    })
    needlePointTypeId: string;

    @Column('varchar', {
        name: 'needle_sizes_id',
        nullable: false,
    })
    needleSizesId: string;

    @Column('boolean', {
        name: 'is_active',
        default: true,
    })
    isActive: boolean;

    @Column('datetime', {
        name: 'created_at',
        default: () => 'CURRENT_TIMESTAMP',
    })
    createdAt: Date;

    @Column('varchar', {
        name: 'created_user',
        nullable: true,
    })
    createdUser: string;

    @Column('datetime', {
        name: 'updated_at',
        nullable: true,
    })
    updatedAt: Date;

    @Column('varchar', {
        name: 'updated_user',
        nullable: true,
    })
    updatedUser: string;

    @Column('int', {
        name: 'version_flag',
        default: 1,
    })
    versionFlag: number;

    @Column('varchar', {
        name: 'company_code',
        nullable: false,
    })
    companyCode: string;
}
